import React from 'react';

const ServiceLocationBadges = ({
  serviceLocationTypes,
  businessName,
  className = '',
}) => {
  if (!serviceLocationTypes || (!serviceLocationTypes.hasFixed && !serviceLocationTypes.hasMobile)) {
    return null;
  }

  const { hasFixed, hasMobile } = serviceLocationTypes;

  let message;
  if (hasMobile && hasFixed) {
    message = businessName
      ? `🏠 Available at your location or in person at ${businessName} — you'll choose after selecting services.`
      : '🏠 Available at your location or in person — you\'ll choose after selecting services.';
  } else if (hasMobile) {
    message = '🏠 All services are performed at your location — you\'ll enter your address after selecting services.';
  } else {
    message = businessName
      ? `📍 All appointments take place at ${businessName}.`
      : '📍 All appointments take place at our location.';
  }

  return (
    <div className={`rounded-lg border border-themed bg-themed-card-elevated p-4 ${className}`}>
      <p className="text-sm text-themed-secondary">
        {message}
      </p>
    </div>
  );
};

export default ServiceLocationBadges;